import React, { Component } from 'react';
import classnames from 'classnames';
import './index.less';

export default class Login extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loginView: false,
            loginViewSrc: '',
            loading: false,
            words: [
                '为用户省钱',
                '极智生活，价值取胜',
                '为用户省钱',
                '极智生活，价值取胜',
                '为用户省钱',
            ],
        };
    }

    getReturnUrl = () => {
        return `${window.location.origin}/tenant`;
    };

    render() {
        return (
            <div className="login-container">
                <div className={`login-header-box`}>
                    <img src="//misc.360buyimg.com/lib/img/e/logo-201305-b.png" />
                    <img
                        className="word"
                        src="//misc.360buyimg.com/user/passport/1.0.0/css/i/l-icon.png"
                    />
                </div>
                <div className={`login-content-box`}>
                    <div className={`login-iframe-box`}>
                        <div className={`login-iframe-content`}>
                            <div className="login-wrap-title">京东账号</div>
                            <iframe
                                className="login-iframe"
                                src={`https://passport.jd.com/common/loginPage?ReturnUrl=${this.getReturnUrl()}&from=jxsaas_jd&regTag=2&pwdTag=2&btnTag=a726f28814913f8f`}
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
